import { Icons } from "@ir/ui";
import { useAnalyticsScoreCards } from "@/hooks";
import AnalyticsScoreCard, { ScoreCardConfig } from "./AnalyticsScoreCard";

const CONFIG: ScoreCardConfig = {
  title: "Raised for Dispute",
  theme: "error",
  icon: Icons.AlertTriangle,
};

const RaisedForDisputeCard = () => {
  const { raisedForDispute } = useAnalyticsScoreCards();
  return <AnalyticsScoreCard config={CONFIG} data={raisedForDispute} />;
};

export default RaisedForDisputeCard;
